/**
 * @file Purchase Album Folder Layout.
 */

import React from 'react';
import PropTypes from 'prop-types';

import OnboardingLayout from '../../apps/temp/views/onboarding/OnboardingLayout/OnboardingLayout';

const propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
};

const PurchaseAlbumFolderLayout = ({ children }) => (
  <OnboardingLayout>{children}</OnboardingLayout>
);

PurchaseAlbumFolderLayout.propTypes = propTypes;

export default PurchaseAlbumFolderLayout;
